/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdDescriptionsItemProps, TdDescriptionsProps } from './type';

export const descriptionsDefaultProps: TdDescriptionsProps = {
  bordered: false,
  column: 2,
  itemLayout: 'horizontal',
  layout: 'horizontal',
  size: 'medium',
  tableLayout: 'auto',
};

export const descriptionsItemDefaultProps: TdDescriptionsItemProps = { span: 1 };
